import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { ControlProps } from '@/app/components/search/components/Form';
import { getMultilistboxValue, OPTIONS_SORT } from '../utils';
import getListboxContainer from './getListboxContainer';
import FilterContainer from '../FilterContainer';
import type { CommonProps } from './CommonProps';

type GetFaunaField = {
  searchParams: SearchParams;
  commonProps: CommonProps;
  t: TranslationFunction;
};

export const getFaunaOptions = ({ t, isWaiting }: { t: TranslationFunction; isWaiting?: boolean }) => [
  { value: 1, label: t('vacation.oss.filters.fauna.corals'), disabled: isWaiting },
  { value: 2, label: t('vacation.oss.filters.fauna.exotic_fish'), disabled: isWaiting },
  { value: 3, label: t('vacation.oss.filters.fauna.stingrays'), disabled: isWaiting },
  { value: 4, label: t('vacation.oss.filters.fauna.turtles'), disabled: isWaiting },
];

const getFaunaField = ({ searchParams, commonProps, t }: GetFaunaField): ControlProps => {
  const { isWaiting } = commonProps;

  return getListboxContainer({
    fieldName: URLParameters.FAUNA,
    containerName: FilterContainer.FaunaContainer,
    containerTitle: t('vacation.oss.filters.fauna.title'),
    options: getFaunaOptions({ t, isWaiting }),
    value: getMultilistboxValue(searchParams[URLParameters.FAUNA], true),
    fieldClassName: '',
    optionsSort: OPTIONS_SORT.ALPHABET,
    ...commonProps,
  });
};

export default getFaunaField;
